'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Image from 'next/image';
import { cn } from '@/lib/utils';
export function ThemeAwareLogo({ className, alt = 'Ventus Logo' }) {
    const [theme, setTheme] = useState('dark');
    useEffect(() => {
        // Detektuj trenutnu temu iz document.documentElement
        const detectTheme = () => {
            const isDark = document.documentElement.classList.contains('dark');
            setTheme(isDark ? 'dark' : 'light');
        };
        detectTheme();
        // MutationObserver za praćenje promena teme
        const observer = new MutationObserver(detectTheme);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class'],
        });
        return () => observer.disconnect();
    }, []);
    const logoSrc = theme === 'dark' ? '/Logo transparent.webp' : '/Logo pozadina 2 .webp';
    return (_jsx(Image, { src: logoSrc, alt: alt, width: 200, height: 50, className: cn('transition-opacity duration-300', className) }));
}
